import { InputType } from "../types";

export const SelectInput: InputType = [{ value: 12, type: 'number' }];
